import { useEffect } from 'react';
import { useTimerStore } from './timerStore';

/**
 * Section 10 item 4: a SINGLE interval for the whole application, ticking once
 * per second and driving every visible clock. Not one interval per card. On the
 * overview with ten live cards that would be ten timers fighting React.
 *
 * Mounted exactly once, at the top of the app.
 *
 * It used to listen for pointer, key, scroll, touch and visibility events as
 * well, to feed the ninety second idle pause. Section 1 of the request of
 * 20 September 2026 removed that rule: the clock runs until Pause or Done, so
 * there is nothing for the listeners to tell it and they are gone. The tick now
 * only advances the shared wall clock, which every clock on screen reads.
 */
export function useTicker(): void {
  useEffect(() => {
    const { tick } = useTimerStore.getState();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
}
